import { Button } from "@tblabs/truffle";


export class PrimaryButton extends Button
{
    constructor(text: string, action?: (self: PrimaryButton) => void)
    {
        super(text, action);

        this.Class("btn-action-primary");
        this.WidthAuto();
    }
}
